// base
import { useContext, useEffect, useState } from 'react';

// contexts
import { LoadingContext } from 'contexts';

export const useLoading = () => {
  const context = useContext(LoadingContext);

  const [isNotProvided, setIsNotProvided] = useState(false);

  useEffect(() => {
    if (context) {
      setIsNotProvided(false);
    } else {
      console.log('LoadingContext is not provided');
      setIsNotProvided(true);
    }

    return () => {
      setIsNotProvided(false);
    };
  }, [context]);

  return {
    ...context,
    isNotProvided
  };
};
